module.exports = __webpack_public_path__ + "static/img/info_content_box.c4d88dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/info_content_box.png
// module id = P1wR
// module chunks = 1